var Docs, Header;

Header = require('./header');

Docs = require('./docs');


/**
 * Where it all begins
 */

window.addEventListener('DOMContentLoaded', function() {
  new Docs;
  return new Header;
});

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL29wdC9idWlsZC9yZXBvL2Fzc2V0cy9qcy9tYWluLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9vcHQvYnVpbGQvcmVwby9hc3NldHMvanMvbWFpbi5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxNQUFBLEdBQVMsT0FBQSxDQUFRLFVBQVI7O0FBQ1QsSUFBQSxHQUFTLE9BQUEsQ0FBUSxRQUFSOzs7QUFFVDs7OztBQUdBLE1BQU0sQ0FBQyxnQkFBUCxDQUF3QixrQkFBeEIsRUFBNEMsU0FBQTtFQUMxQyxJQUFJO1NBQ0osSUFBSTtBQUZzQyxDQUE1QyJ9
